let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h1r9e")).then(() => parcelRequire('Y3Lzf'));